module.exports = __webpack_public_path__ + "img/39.3b2723f0.png";